import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const MenuMoreHorizontal = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.33333 9.66667C3.2538 9.66667 4 8.92047 4 8C4 7.07954 3.2538 6.33334 2.33333 6.33334C1.41286 6.33334 0.666664 7.07954 0.666664 8C0.666664 8.92047 1.41286 9.66667 2.33333 9.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M8 9.66667C8.92047 9.66667 9.66667 8.92047 9.66667 8C9.66667 7.07954 8.92047 6.33334 8 6.33334C7.07954 6.33334 6.33334 7.07954 6.33334 8C6.33334 8.92047 7.07954 9.66667 8 9.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M13.6667 9.66667C14.5871 9.66667 15.3333 8.92047 15.3333 8C15.3333 7.07954 14.5871 6.33334 13.6667 6.33334C12.7462 6.33334 12 7.07954 12 8C12 8.92047 12.7462 9.66667 13.6667 9.66667Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
  </svg>,
  'MenuMoreHorizontal'
);
